var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState, useRef, useContext, useMemo, } from 'react';
import './notes.scss';
import { Button } from '../../shared';
import { services } from '../../../shared';
import { pageContentValues } from '../../../shared/types/constants';
import { LoaderContext } from '../../../shared/utils/loader/loader-wrapper';
import { DefaultLoadingComponent } from '../../../shared/utils/loader/default-loading-component';
import { useLoader } from '../../../shared/utils';
export var Notes = function (_a) {
    var notes = _a.notes, caseId = _a.caseId, customerId = _a.customerId, fetchData = _a.fetchData;
    var inputRef = useRef(null);
    var _b = useState(), data = _b[0], setData = _b[1];
    var _c = useState(''), societyName = _c[0], setSocietyName = _c[1];
    var _d = useState([]), displaySeeMoreLabel = _d[0], setDisplaySeeMoreLabel = _d[1];
    var _e = useState([]), displaySeeLessLabel = _e[0], setDisplaySeeLessLabel = _e[1];
    var _f = useState(false), isNoteButtonEnabled = _f[0], setIsNoteButtonEnabled = _f[1];
    var saveNote = function (e) {
        caseNotesSetIsLoading(true);
        var noteText = inputRef.current.value;
        if (noteText !== '') {
            setIsNoteButtonEnabled(true);
            services.saveNote(caseId, customerId, inputRef.current.value).then(function (SuccessResult) {
                if (SuccessResult) {
                    fetchData();
                    inputRef.current.value = '';
                    setIsNoteButtonEnabled(false);
                }
            });
        }
    };
    var fetchSocietyName = function () { return __awaiter(void 0, void 0, void 0, function () {
        var moduleText;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getModuleText(pageContentValues.societyName.content)];
                case 1:
                    moduleText = (_a.sent()).data;
                    setSocietyName(moduleText.description);
                    return [2 /*return*/];
            }
        });
    }); };
    var seeMore = function (e) {
        var note = notes.find(function (note) { return note.id === Number(e.currentTarget.getAttribute('data-value')); });
        var index = notes.indexOf(note);
        var seeMore = Object.assign([], displaySeeMoreLabel);
        var seeLess = Object.assign([], displaySeeLessLabel);
        seeLess[index] = true;
        seeMore[index] = false;
        setDisplaySeeMoreLabel(seeMore);
        setDisplaySeeLessLabel(seeLess);
    };
    var hasTextExceededMax = function (note) {
        return note.text.length > 40 * 5 - 3;
    };
    var seeLess = function (e) {
        var note = notes.find(function (note) { return note.id === Number(e.currentTarget.getAttribute('data-value')); });
        var index = notes.indexOf(note);
        var seeMore = Object.assign([], displaySeeMoreLabel);
        var seeLess = Object.assign([], displaySeeLessLabel);
        seeLess[index] = false;
        seeMore[index] = true;
        setDisplaySeeMoreLabel(seeMore);
        setDisplaySeeLessLabel(seeLess);
    };
    useEffect(function () {
        setData(notes);
        fetchSocietyName();
        setDisplaySeeMoreLabel(notes.map(function (note) { return hasTextExceededMax(note); }));
        setDisplaySeeLessLabel(notes.map(function () { return false; }));
    }, [caseId, customerId, notes]);
    var loadingData = useContext(LoaderContext);
    var caseNotesSetIsLoading = useLoader({ identifier: 'caseNotes' }).caseNotesSetIsLoading;
    var isLoading = useMemo(function () { return loadingData.isLoading; }, [loadingData.isLoading]);
    return (React.createElement("div", { className: "notes" },
        React.createElement("div", { className: "notes__text_field" },
            React.createElement("input", { type: "text", ref: inputRef, className: "c-input", placeholder: "Type note..." }),
            React.createElement("span", { className: "notes__add_entry" },
                React.createElement(Button, { type: "button", disabled: isNoteButtonEnabled, variant: "primary", icon: "submitarrow", iconPosition: "left", onClick: saveNote }))),
        React.createElement("div", { className: "notes__list" },
            isLoading && (React.createElement("div", null,
                React.createElement("div", { className: "notes__sent" },
                    React.createElement("div", { className: "box" },
                        React.createElement(DefaultLoadingComponent, { height: '3rem' }))))),
            (data === null || data === void 0 ? void 0 : data.length) > 0 &&
                (data !== null && data !== void 0 ? data : []).map(function (note, i) {
                    var _a, _b;
                    return (React.createElement("div", { key: i },
                        React.createElement("div", { className: ((_a = note.advisorId) !== null && _a !== void 0 ? _a : 0 > 0) ? 'notes__sent' : 'notes__recd' },
                            React.createElement("p", { className: (((_b = note.advisorId) !== null && _b !== void 0 ? _b : 0) === 0 ? 'notes__recd-text' : 'notes__recd-hidden') + ' u-fs-2' },
                                React.createElement("b", null, societyName)),
                            React.createElement("div", { className: "box" },
                                React.createElement("div", { className: "u-fs-2" },
                                    note.text.substr(0, 40 * 5 - 3),
                                    displaySeeMoreLabel[i] ? '...' : '',
                                    displaySeeLessLabel[i] ? note.text.substr(40 * 5 - 3) : ''),
                                React.createElement("button", { onClick: seeMore, "data-value": note.id, className: hasTextExceededMax(note) && displaySeeMoreLabel[i] ? 'notes__text u-fs-2' : 'hidden-label' },
                                    React.createElement("b", null, "See more")),
                                React.createElement("button", { onClick: seeLess, "data-value": note.id, className: hasTextExceededMax(note) && displaySeeLessLabel[i] ? 'notes__text u-fs-2' : 'hidden-label' },
                                    React.createElement("b", null, "See less")),
                                React.createElement("span", { className: "u-flex__align-right" },
                                    React.createElement("small", null, note.formattedCreated))))));
                }))));
};
